import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Grid
} from "@mui/material";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import { formatDateText } from "../CommonFunctions";
import { useEffect, useState } from "react";
import { Button } from "rsuite";

export default function StayDetails({ tenancyId, tenancyDetails, handleTenancyUpdate }) {
    const [openEdit, setOpenEdit] = useState(false);

  // Local editable state
  const [editData, setEditData] = useState({ });


  useEffect(() => {
  if (tenancyDetails) {
    setEditData({
      firstArrivalDate: tenancyDetails.firstArrivalDate || "",
      rate: tenancyDetails.rate,
      deposit: tenancyDetails.deposit,
      adults: tenancyDetails.adults,
      children: tenancyDetails.children,
      hasPets: tenancyDetails.hasPets,
    });
  }
}, [tenancyDetails]);


  const handleEditChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    // Update values in parent/backend if required
    handleTenancyUpdate(tenancyId, editData);

    setOpenEdit(false);
  };
 
    console.log(tenancyDetails)
  return (
    <Box
      sx={{
        borderRadius: 1,
        overflow: "hidden",
        bgcolor: "white",
        px: 2,
      }}
    >
      <Box component={Paper} elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            bgcolor: "#e8f3ff",
            px: 1.5,
            py: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "18px"
          }}
        >
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.95rem", lineHeight: 0.2 }}
          >
            Stay Details
          </Typography>

          <Link
            to="#"
            style={{
              color: "#0066ff",
              fontSize: "0.85rem",
              fontWeight: 500,
              textDecoration: "underline"
            }}
            onClick={() => setOpenEdit(true)}
          >
            Edit
          </Link>
        </Box>

        {/* TABLE */}
        <TableContainer>
          <Table
            sx={{
              "& th": {
                fontWeight: 600,
                bgcolor: "white",
                borderBottom: "1px solid #e3e3e3",
                py: 1,
                px: 2
              },
              "& td": {
                borderBottom: "1px solid #efefef",
                fontSize: "0.9rem",
                py: 1,
                px: 2
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>First Arrival Date</TableCell>
                <TableCell>Rent</TableCell>
                <TableCell>Deposit</TableCell>
                <TableCell>Adults</TableCell>
                <TableCell>Children</TableCell>
                <TableCell>Pets</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell>{formatDateText(tenancyDetails.firstArrivalDate) || "—"}</TableCell>
                <TableCell><NumericFormat value={tenancyDetails.rate} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>
                <TableCell><NumericFormat value={tenancyDetails.deposit} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>
                <TableCell>{tenancyDetails.adults || 0}</TableCell>
                <TableCell>{tenancyDetails.children || 0}</TableCell>
                <TableCell>{tenancyDetails.hasPets || 0}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {/* EDIT MODAL */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="sm">
        <DialogTitle>Edit Stay Details</DialogTitle>
        <DialogContent dividers>
            <Box mt={1}>
                <Grid container spacing={2}>
                
                <Grid item xs={12} md={6}>
                    <TextField
                    label="First Arrival Date"
                    type="date"
                    value={editData.firstArrivalDate}
                    onChange={(e) => handleEditChange("firstArrivalDate", e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                    label="Rent"
                    type="number"
                    value={editData.rate}
                    onChange={(e) => handleEditChange("rate", e.target.value)}
                    fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                    label="Deposit"
                    type="number"
                    value={editData.deposit}
                    onChange={(e) => handleEditChange("deposit", e.target.value)}
                    fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                    label="Adults"
                    type="number"
                    value={editData.adults}
                    onChange={(e) => handleEditChange("adults", e.target.value)}
                    fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                    label="Children"
                    type="number"
                    value={editData.children}
                    onChange={(e) => handleEditChange("children", e.target.value)}
                    fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                    label="Pets"
                    type="number"
                    value={editData.hasPets}
                    onChange={(e) => handleEditChange("hasPets", e.target.value)}
                    fullWidth
                    />
                </Grid>

                </Grid>
            </Box>
            </DialogContent>


        <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    
  );
}
